var uploadDocuments = {
    attachedFiles: 'Archivos Adjuntos',
    deleteConfirmation: '¿Está seguro de que desea eliminar este archivo?',
    dragDropText: 'Arrastre y suelte o haga clic para <0>explorar</0>',
    exit: 'Tiene archivos adjuntos que no han sido enviados. ¿Está seguro de que desea salir?',
    fileSizeText: "El tama\u00F1o m\u00E1ximo combinado para todos los archivos adjuntos es de: {{maxFileSize}}",
    fileTypes: 'Tipos de archivos compatibles: PNG, JPG o PDF',
    headerTitle: 'Agregue Documentos',
    maxAttachments: 'Número máximo de archivos adjuntos: {{maxAttachments}}',
    maxAttachmentsReached: 'Has alcanzado tu máximo de {{maxAttachments}} archivos adjuntos',
    modalTitle: 'Agregar Documentos o Comentarios',
    noAttachedFiles: 'No tiene archivos adjuntos.',
    noComments: 'No se agregaron comentarios.',
    noFiles: 'No se tienen archivos adjuntos.',
    pagination: 'de',
    pleaseSubmit: 'Por favor envíe estos archivos antes de agregar más.',
    pleaseWait: 'Por favor, espere mientras ejecutamos un análisis de seguridad en sus archivos.',
    redirect: 'Cuando esté hecho, lo redirigiremos automáticamente.',
    reminder: 'Por favor solo utilice letras, números y caracteres admitidos como:',
    sectionOptional: '(opcional)',
    supportingComments: 'Comentarios de Respaldo',
    supportingDocuments: 'Documentos de Respaldo',
    tapToBrowseDocument: '<0>Toque</0> para explorar documentos',
    title: 'Por favor, cargue cualquier documentación de respaldo. Los documentos de respaldo pueden ser los siguientes: recibos por la venta o crédito bajo disputa, notificaciones de entrega o comunicaciones con el Comerciante o Proveedor.',
    uploadApiError: 'Encontramos un problema y sus archivos no se pudieron enviar. Por favor, intente nuevamente más tarde.',
    uploadError: 'Hubo un problema al cargar tus archivos. Pruebe con un archivo diferente.',
    uploadSuccess: 'Sus archivos han sido enviados exitosamente.'
};
export default uploadDocuments;
//# sourceMappingURL=uploadDocuments.js.map